







































// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// components
import { Input, Radio } from '@/components/form'

// Vuelidate
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'

// models
import { CostCenterForm } from '@/models/config'

// constants
import { optionsStatus } from '@/constants'

// utils
import { loading, alerts } from '@/utils'

// services
import { CostCenterService } from '@/services/config'

@Component({
    name: 'FormCreateEditCostCenter',
    components: {
        Input,
        Radio
    },
    mixins: [validationMixin]
})
export default class FormCreateEditCostCenter extends Vue {
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ required: true }) costCenter!: CostCenterForm
    @Prop({ type: Number, default: null }) idEdit!: number|null

    optionsStatus = optionsStatus
    form: CostCenterForm = {
        name: '',
        description: '',
        is_active: true
    }

    created () {
        if (this.idEdit) {
            this.form = this.costCenter
        }
    }

    @Validations()
    validations () {
        return {
            form: {
                name: { required, minLength: minLength(2) },
                description: { required },
                is_active: { required }
            }
        }
    }

    async save () {
        this.$v.$touch()
        if (!this.$v.$anyError) {
            loading('show')
            try {
                if (this.actionForm === 'update' && this.idEdit !== null) {
                    await CostCenterService.update(this.idEdit, this.form)
                } else {
                    await CostCenterService.create(this.form)
                }
                alerts.success()
                this.form = {
                    name: '',
                    description: '',
                    is_active: true
                }
                this.$emit('save-success')
            } catch (e) {
                alerts.error('Se ha presentado errores en la operación')
            }
            loading('hide')
            this.$v.$reset()
        } else {
            alerts.error('Debe completar todos los campos requeridos')
        }
        loading('hide')
    }
}
